export const DEFAULT_PAGE_SIZE = 36
export const RECOMMENDED_PLAYLIST_COUNT = 5
